import PropTypes from 'prop-types';
import React from 'react';
import { FDStack, FDTitleText } from '@facet-wealth/design';

function TitleWithRequired({
  text, required,
}) {
  return (
    <FDStack direction={'row'}>
      <FDTitleText value={text} />
      {required ? <FDTitleText value={'*'} color={'textError'} /> : null}
    </FDStack>
  );
}

TitleWithRequired.propTypes = {
  required: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

TitleWithRequired.defaultProps = {
  required: 'false',
};

export default TitleWithRequired;
